<template>
    <div class="p-1">
    <bubble-menu :editor="editor" :tippy-options="{ duration: 100 }" v-if="editor">
      <button @click="editor.chain().focus().toggleBold().run()" :class="[{ 'active': editor.isActive('bold') },'btn', 'btn-light',' btn-sm']">
        <i class="fa fa-bold" />
      </button>
      <button @click="editor.chain().focus().toggleItalic().run()" :class="[{ 'active': editor.isActive('italic') },'btn', 'btn-light',' btn-sm']">
        <i class="fa fa-italic" />
      </button>
      <button @click="editor.chain().focus().toggleStrike().run()" :class="[{ 'active': editor.isActive('strike') },'btn', 'btn-light',' btn-sm']">
        <i class="fa fa-strikethrough" />
      </button>
    </bubble-menu>

    <div v-if="editor" class="border rounded-top p-2">

      <button @click="editor.chain().focus().toggleBold().run()" :class="[{ 'is-active': editor.isActive('bold') },'btn','btn-light']">
        <i class="fa fa-bold" />
      </button>
      <button @click="editor.chain().focus().toggleItalic().run()" :class="[{ 'is-active': editor.isActive('italic') },'btn','btn-light']">
        <i class="fa fa-italic" />
      </button>
      <button @click="editor.chain().focus().toggleStrike().run()" :class="[{ 'is-active': editor.isActive('strike') },'btn','btn-light']">
        <i class="fa fa-strikethrough" />
      </button>
      <button @click="editor.chain().focus().toggleCode().run()" :class="[{ 'is-active': editor.isActive('code') },'btn','btn-light']">
        <i class="fa fa-code" aria-hidden="true"></i>
      </button>
      <button @click="editor.chain().focus().unsetAllMarks().run()" :class="['btn','btn-light']">
        <i class="fa fa-eraser" aria-hidden="true"></i>
      </button>
      <button @click="editor.chain().focus().clearNodes().run()" :class="['btn','btn-light']">
        clear nodes
      </button>
      <button @click="editor.chain().focus().setParagraph().run()" :class="[{ 'is-active': editor.isActive('paragraph') },'btn','btn-light']">
        <i class="fa fa-paragraph" />
      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 1 }).run()" :class="[{ 'is-active': editor.isActive('heading', { level: 1 }) },'btn','btn-light']">
        H1
      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 2 }).run()" :class="[{ 'is-active': editor.isActive('heading', { level: 2 }) },'btn','btn-light']">
        H2
      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 3 }).run()" :class="[{ 'is-active': editor.isActive('heading', { level: 3 }) },'btn','btn-light']">
        H3
      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 4 }).run()" :class="[{ 'is-active': editor.isActive('heading', { level: 4 }) },'btn','btn-light']">
        H4
      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 5 }).run()" :class="[{ 'is-active': editor.isActive('heading', { level: 5 }) },'btn','btn-light']">
        H5
      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 6 }).run()" :class="[{ 'is-active': editor.isActive('heading', { level: 6 }) },'btn','btn-light']">
        H6
      </button>
      <button @click="editor.chain().focus().toggleBulletList().run()" :class="[{ 'is-active': editor.isActive('bulletList') },'btn','btn-light']">
        <i class="fa fa-list" />
      </button>
      <button @click="editor.chain().focus().toggleOrderedList().run()" :class="[{ 'is-active': editor.isActive('orderedList') },'btn','btn-light']">
        <i class="fa fa-list-ol" />
      </button>
      <button @click="editor.chain().focus().toggleCodeBlock().run()" :class="[{ 'is-active': editor.isActive('codeBlock') },'btn','btn-light']">
        code block
      </button>
      <button @click="editor.chain().focus().toggleBlockquote().run()" :class="[{ 'is-active': editor.isActive('blockquote') },'btn','btn-light']">
        <i class="fa fa-quote-left" />
      </button>
      <button @click="editor.chain().focus().setHorizontalRule().run()" :class="['btn','btn-light']">
        horizontal rule
      </button>
      <button @click="editor.chain().focus().setHardBreak().run()" :class="['btn','btn-light']">
        hard break
      </button>
      <button @click="editor.chain().focus().undo().run()" :class="['btn','btn-light']">
        <i class="fa fa-mail-reply" />
      </button>
      <button @click="editor.chain().focus().redo().run()" :class="['btn','btn-light']">
        <i class="fa fa-mail-forward" />
      </button>

      <b-dropdown id="dropdown-1" text="Contact Personalisations" class="m-md-2">
        <b-dropdown-item @click="editor.commands.insertContent('[firstname fallback=there]')">First Name</b-dropdown-item>
        <b-dropdown-item @click="editor.commands.insertContent('[lastname fallback=there]')">Last Name</b-dropdown-item>
        <b-dropdown-item @click="editor.commands.insertContent('[companyname fallback=your company]')">Company Name</b-dropdown-item>
        <b-dropdown-item @click="editor.commands.insertContent('[emailaddress]')">Email</b-dropdown-item>
        <b-dropdown-item @click="editor.commands.insertContent('[telephone]')">Telephone</b-dropdown-item>
      </b-dropdown>

    </div>

    <editor-content :editor="editor" class="p-2 border rounded-bottom border-top-0" style="min-height: calc(100vh - 300px);" />
  </div>
</template>

<script>
import StarterKit from '@tiptap/starter-kit'
import { BubbleMenu,Editor, EditorContent } from '@tiptap/vue-2'

export default {
  components: {
    EditorContent,
    BubbleMenu,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      editor: null,
    }
  },

  watch: {
    value(value) {
      // HTML
      const isSame = this.editor.getHTML() === value

      // JSON
      // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)

      if (isSame) {
        return
      }

      this.editor.commands.setContent(value, false)
    },
  },

  mounted() {
    this.editor = new Editor({
      content: this.value,
      extensions: [
        StarterKit,
      ],
      onUpdate: () => {
        // HTML
        this.$emit('input', this.editor.getHTML())

        // JSON
        // this.$emit('input', this.editor.getJSON())
      },
    })
  },

  beforeDestroy() {
    this.editor.destroy()
  },
}
</script>

<style lang="scss">
/* Basic editor styles */
.ProseMirror {
  > * + * {
    margin-top: 0.75em;
  }
}
</style>
<style >

.ProseMirror:focus {
    outline: none;
  }

</style>